const overviewBlocks = document.querySelectorAll('.program-overview');

overviewBlocks.forEach((block) => {
  const modal = block.querySelector('.event-modal');
  if (!modal) return;

  const eventItems = block.querySelectorAll('.event-item');

  function openModal(item) {
    const group = item.closest('.event-group');
    const info = group.querySelector('.event-information');
    const title = item.querySelector('.event-title').textContent;
    const id = info.dataset.id;

    modal.innerHTML = `<div class="event-modal__content"><button class="event-modal__close" aria-label="Close">&times;</button><h2 class="event-modal__title">${title}</h2>${info.innerHTML}</div>`;
    modal.classList.add('active');
    document.querySelector('body').classList.add('no-scroll');

    if (id) {
      history.replaceState(null, '', '#' + id);
    }

    modal.querySelector('.event-modal__close').addEventListener('click', () => {
      closeModal();
    });
  }

  function closeModal() {
    modal.classList.remove('active');
    document.querySelector('body').classList.remove('no-scroll');
    history.replaceState(null, '', location.pathname + location.search);
  }

  eventItems.forEach((item) => {
    const link = item.querySelector('a');
    if (!link) return;

    link.addEventListener('click', (e) => {
      if(link.classList.contains('prevent-default')) {
        e.preventDefault();
        openModal(item);
      }
    });
  });

  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });

  // Open modal and scroll to section if URL hash matches an event
  const hash = window.location.hash.slice(1);
  if (hash) {
    const info = block.querySelector(`.event-information[data-id="${CSS.escape(hash)}"]`);
    if (info) {
      const item = info.closest('.event-group').querySelector('.event-item');
      if (item) {
        block.scrollIntoView({ behavior: 'instant', block: 'start' });
        openModal(item);
      }
    }
  }
});

function equalizeColumnTops() {
  document.querySelectorAll('.program-overview').forEach((block) => {
    const tops = [...block.querySelectorAll('.column-top')];

    // Reset all first
    tops.forEach((el) => (el.style.minHeight = ''));

    // Only proceed if at least one column-top has a .column-text element
    if (!tops.some((el) => el.querySelector('.column-text'))) return;

    const w = window.innerWidth;
    let group = [];

    if (w >= 1200) {
      group = tops;
    } else if (w >= 1024) {
      group = tops.slice(-2);
    } else {
      return;
    }

    const max = Math.max(...group.map((el) => el.offsetHeight));
    group.forEach((el) => (el.style.minHeight = max + 'px'));
  });
}

equalizeColumnTops();
window.addEventListener('resize', equalizeColumnTops);